<template>
  <main class="Vlt-main Vlt-main--dark mainAdminContainer">
    <section>
      <h3>
          <span>
            <vlt-icon class="Vlt-black Vlt-margin--bottom1" icon="history"/>
          </span>
        {{$t('message.dashboard.adminDashboard.history')}}
      </h3>
      <hr class="hr--short">
    </section>

    <vlt-table
      v-if="!loading"
      :columns="columns"
      :rows="historyData"
      :pagination="historyData.length > pageSize"
      :pageSize="pageSize"
      :emptyMessage="$t('message.dashboard.no_records')"
    >
      <template slot="item" slot-scope="slotProps">
        <td >{{ slotProps.item.date }}</td>
        <td >{{ slotProps.item.duration }}</td>
        <td >{{ slotProps.item.from }}</td>
        <td >{{ slotProps.item.to }}</td>
      </template>
    </vlt-table>
  </main>
<!--  </div>-->
</template>

<script>
import {
  VltIcon,
  VltButton,
  VltTable,
} from '@vonagevolta/vue';
import { mapActions, mapGetters } from 'vuex';
import { GET_USER_HISTORY } from 'Store/action-types';

export default {
  name: 'History',
  components: {
    VltIcon,
    VltButton,
    VltTable
  },
  data() {
    return {
        loading: false,
        term: '',
        columns: [
            { title: 'Date', property: 'date', sortable: true },
            { title: 'Duration', property: 'duration', sortable: true },
            { title: 'From', property: 'from', sortable: true },
            { title: 'Stream', property: 'to', sortable: true },
        ],
        pageSize: 10,
    }
  },
  props: {

  },

  watch: {
    historyData: {
      immediate: true,
      handler(newProp) {
        if (newProp && newProp.length) {
          console.log('=========== Fetched history: ', newProp);
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      historyData: 'getHistory',
      isAdmin: 'isAdmin',
    }),
  },
  methods: {
    ...mapActions({
      fetchHistory:  `${GET_USER_HISTORY}`,
    }),
    init() {
        this.fetchHistory(100);
    },
  },
  created() {
    if (!this.isAdmin) {
        this.$router.push({name: 'dashboard'})
    }
    this.init();
  },
};
</script>

<style lang="scss" scoped>
  .app-main {
    flex: 1;
    //height: 100vh;
    overflow: hidden;
    padding: 15px 20px 20px 10px;
    //height: calc(100vh - 70px);
  }

  .flexContainer {
    display: flex;
    align-items: stretch
  }

  .linkImg {
    width: 130px;
  }

  .Vlt-margin--left1 {
    margin-left: 10px;
  }

  .Vlt-margin--left2 {
    margin-left: 20px;
  }

  .stretch-height {
    height: 100%;
  }

  .Vlt-template {
    margin-top: 20px;
  }
.mainAdminContainer {
  height: 82vh;
}
.Vlt-main {
  overflow: scroll;
  overflow-x: hidden;
}
.Vlt-main::-webkit-scrollbar {
  width: 0px; /* remove scrollbar space */
}
</style>
